import {computed} from "mobx";
import {LINEUPS} from "../../../../../widgets/lineups-widget/lineups-widget.consts";
import {LineupsMemberInjuryDomainModel} from "./lineups-member-injury-domain-model";
import {BaseViewModel} from "../../../../../infrastructure/models/base-view-model";

export class LineupsMemberInjuryViewModel extends BaseViewModel {
  domainModel: LineupsMemberInjuryDomainModel;

  get imageId(): Number {
    return this.domainModel.imageId;
  }

  @computed get categoryId(): LINEUPS.INJURY_CATEGORY{
    return this.domainModel.categoryId;
  }

  @computed get reason(): String{
    return this.domainModel.reason;
  }

  @computed get expectedReturn(): String{
    return this.domainModel.expectedReturn;
  }
}
